var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { key: "sign-up", staticClass: "t-onboard__body" }, [
    _c("div", { staticClass: "t-onboard__main" }, [
      _c(
        "div",
        { staticClass: "t-onboard__content" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "t-onboard__title" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  !_vm.$isEmpty(_vm.memberships) && !_vm.createNewWorkspace
                    ? _vm.$t("onboard.register.workspace.join")
                    : _vm.$t("onboard.register.workspace.title")
                ) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _vm.loaded
            ? _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
                !_vm.$isEmpty(_vm.memberships) && !_vm.createNewWorkspace
                  ? _c(
                      "div",
                      { staticClass: "t-onboard__form" },
                      [
                        _c(
                          "div",
                          { staticClass: "t-onboard__list" },
                          _vm._l(_vm.memberships, function (membership) {
                            return _c(
                              "div",
                              {
                                key: membership.id,
                                staticClass: "t-onboard__list-item t-ta--left",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "t-profile t-profile__flex" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "t-profile__shrink" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "t-profile__box" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  membership.display_name &&
                                                    membership.display_name.charAt(
                                                      0
                                                    )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "t-profile__grow t-mar--l-mi",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "t-profile__title" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  membership.display_name
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "t-fs--body" },
                                          [
                                            _vm._v(
                                              "By " + _vm._s(membership.owner)
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "t-profile__aside t-mar--l-mi",
                                      },
                                      [
                                        _c(
                                          "t-button",
                                          {
                                            staticClass: "t-fs--body t-link",
                                            attrs: {
                                              variant: "action",
                                              loading: _vm.joinWorkspaceLoader,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.takeMeToWorkspace(
                                                  membership.name
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "generic.button.join"
                                                    )
                                                  )
                                              ),
                                            ]),
                                            _c("i", {
                                              staticClass:
                                                "fas fa-angle-right fa-fw",
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "t-onboard__divider t-mar--t-lg t-fs--subtitle",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("generic.text.or")) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "t-button",
                          {
                            staticClass: "t-mar--t-lg",
                            attrs: {
                              fluid: "",
                              loading: _vm.loader,
                              size: "medium",
                              variant: "primary-ghost",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.createNewWorkspaceInstead()
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "onboard.register.btn.create_new_workspace"
                                  )
                                )
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "t-onboard__form",
                        class: { "t-mar--l-no": !_vm.$isMobile },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "t-onboard__field" },
                          [
                            _c("t-input", {
                              attrs: {
                                fluid: "",
                                label: _vm.$t(
                                  "onboard.register.workspace.input.label"
                                ),
                                placeholder: _vm.$t(
                                  "onboard.register.workspace.input.placeholder"
                                ),
                                "invalid-message": _vm.workspaceError,
                                "max-length": 50,
                              },
                              on: {
                                update: function ($event) {
                                  return _vm.updateDomainName()
                                },
                                keyup: _vm.keyup,
                                blur: function ($event) {
                                  return _vm.checkDomainNameAllowed()
                                },
                              },
                              model: {
                                value: _vm.workspaceName,
                                callback: function ($$v) {
                                  _vm.workspaceName = $$v
                                },
                                expression: "workspaceName",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "t-onboard__field" },
                          [
                            _c("t-input", {
                              attrs: {
                                fluid: "",
                                label: _vm.$t(
                                  "onboard.register.workspace.domain.label"
                                ),
                                placeholder: _vm.$t(
                                  "onboard.register.workspace.domain.placeholder"
                                ),
                                "invalid-message": _vm.domainNameError,
                                "max-length": 50,
                              },
                              on: {
                                update: function ($event) {
                                  return _vm.checkDomainNameAllowed()
                                },
                              },
                              model: {
                                value: _vm.domainName,
                                callback: function ($$v) {
                                  _vm.domainName = $$v
                                },
                                expression: "domainName",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "t-onboard__description t-mar--t-lg" },
                          [
                            _vm._v(
                              "\n            Your workspace URL is\n            "
                            ),
                            _c("b", { staticClass: "t-fw--bolder" }, [
                              _vm._v(
                                _vm._s(_vm.domainName || "workspace-name") +
                                  ".trainn.co"
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "t-button",
                          {
                            attrs: {
                              variant: "primary",
                              fluid: "",
                              size: "large",
                              loading: _vm.loader,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.createWorkspace()
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("onboard.register.btn.proceed"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "fas fa-arrow-right fa-fw",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "t-onboard__logo" }, [
      _c("img", {
        attrs: {
          src: require("@/lib/assets/images/Trainn-CB-logo.svg"),
          height: "36px",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }